'use client';

import type { UserRole } from '@/contexts/AuthContext';

interface RouteGuardProps {
  children: React.ReactNode;
  adminOnly?: boolean;
  allowedRoles?: UserRole[];
  redirectTo?: string;
}

export default function RouteGuard({ children }: RouteGuardProps) {
  return <>{children}</>;
}
